"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var enumHelper = exports.enumHelper = function enumHelper(enumName, enumMap, field) {
  if (!enumMap[field]) {
    throw new TypeError(field + " is not a valid field of " + enumName);
  }
  if (arguments.length <= 3 ? 0 : arguments.length - 3) {
    return (arguments.length <= 3 ? undefined : arguments[3]) === enumMap[field];
  }
  return enumMap[field];
};